import React from 'react';
import clsx from 'clsx';

import OverlayTooltip from '../OverlayTooltip';

type SlugProps = {
  text: React.ReactNode;
  tooltip?: string | null;
  color?: SlugColorType | false;

  className?: string;
  style?: NullableCSS;
};

const colorsMap: { [x in SlugColorType]: string } = {
  main: 'bg-[#6366f133] text-[#6366f1]',
  gray: 'bg-[#6b728033] text-[#9ca3af]',
  danger: 'bg-[#ef444433] text-[#ef4444]',
  success: 'bg-[#10b98133] text-[#10b981]',
  warning: 'bg-[#f59e0b33] text-[#f59e0b]',
};

const Slug: React.FC<SlugProps> = ({
  text,
  color,
  style,
  tooltip,
  className,
}) => {
  const element = (
    <div
      style={style}
      className={clsx(
        className,
        'truncate',
        'px-sm py-xs font-medium text-tiny rounded-md text-center',
        color !== false ? colorsMap[color || 'main'] : ''
      )}
    >
      {text}
    </div>
  );

  return tooltip ? (
    <OverlayTooltip tooltip={tooltip}>{element}</OverlayTooltip>
  ) : (
    element
  );
};

export default React.memo(Slug) as typeof Slug;
